import React from 'react';
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';
import './Periodical-Highlights-Priority.scss';


class PeriodicalHighlightsPriority extends React.Component {
    constructor(props) {
        super(props);

        this.defineArtigoPrioridade = this.defineArtigoPrioridade.bind(this);

    }

    defineArtigoPrioridade() {
        const {
            prioridade
        } = this.props;

        let _tituloPrioridade;

        switch (prioridade) {
            case 1: _tituloPrioridade = "Destaque Primário"; break;
            case 2: _tituloPrioridade = "Destaque Secundário"; break;
            case 3: _tituloPrioridade = "Destaque Terciário"; break;
            default: _tituloPrioridade = ""; break;
        }
        return _tituloPrioridade;
    }

    render() {
        const {
            idConteudo, imagem, titulo, posicao
        } = this.props.item;

        const { prioridade, toggle } = this.props;
        return (
            <div className="row no-gutters py-2">
                <div className="col-12 col-lg-12">
                    <div className="card w-100 bg-white text-center">
                        <div className="card-body">
                            <h4>{this.defineArtigoPrioridade()}</h4>
                        </div>
                        <div className="row no-gutters">
                            <div className="col-12 col-lg-12 text-center">
                                <button className="btn btn-outline-info" type="button" name="buscarConteudo" onClick={() => toggle(prioridade)}>Buscar conteúdo</button>
                            </div>
                        </div>
                        <div className="row no-gutters text-left mx-3 mt-4 text-truncate">
                            {posicao === undefined ? (
                                <div className="col-12 text-center">
                                    <h4>Destaque não cadastrado</h4>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <div className="col-12 text-truncate">
                                        <span>Título: {titulo}</span>
                                    </div>
                                    <div className="col-12 col-lg-7 py-2">
                                        <label>idConteudo: {idConteudo}</label>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>

                        <div className="row no-gutters">
                            <div className="col-12 w-100">
                                <ImagemFukyo
                                    className={`img-destaque-${posicao || prioridade} img`}
                                    src={imagem}
                                    alt={"imagem do artigo"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}


export default PeriodicalHighlightsPriority;